@if (toasts.length > 0) {
  <div class="acc-toast d-flex flex-column gap-2">
    @for (toast of toasts; track toast.message) {
      <ngb-toast class="acc-toast-item"
                 [class]="toast.classname"
                 [autohide]="true"
                 [delay]="toast.delay"
                 (hidden)="removeToast(toast)"
                 (click)="removeToast(toast)">
        <div class="d-flex align-items-center">
          @if (toast.message.icon) {
            <div>
              <acc-icon [name]="toast.message.icon"></acc-icon>
            </div>
          }
          <div class="ms-3 w-100">
            <p class="mb-0 ">{{ toast.message.message | translate }}</p>
          </div>
        </div>
      </ngb-toast>
    }
  </div>
}
